import { render } from "./OrderRefund.vue?vue&type=template&id=9656126e"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__